<template>
  <div>
    {{ $route.params.id }}
  </div>
</template>

<script>
export default {
  name: 'ItemDetailView',
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>
